import { Field } from 'components'
import { Form, Formik } from 'formik'
import PropTypes from 'prop-types'
import React from 'react'
import { Button, Card } from 'react-bootstrap'
import * as Yup from 'yup'

export function FormCard({ fundraiser, initial, onSubmit }) {
  const validationSchema = Yup.object().shape({
    first_name: Yup.string().required('Required'),
    last_name: Yup.string().required('Required'),
  })

  const handleStudent = (setFieldValue) => (event) => {
    console.log(event.target.value)
    const idx = event.target.value
    const student = fundraiser.roster[idx]
    setFieldValue('roster_idx', idx)
    setFieldValue('first_name', student?.first_name || '')
    setFieldValue('last_name', student?.last_name || '')
  }

  const skip = () => {
    onSubmit({
      first_name: '',
      last_name: '',
    })
  }

  return (
    <Card>
      <Card.Body>
        <Card.Title>Get Started</Card.Title>
        <Card.Text>
          Tell us who you are supporting. If you're not supporting any
          particular individual, you can skip this step.
        </Card.Text>
        <Formik
          initialValues={{
            first_name: '',
            last_name: '',
            roster_idx: '',
            ...initial,
          }}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
          enableReinitialize
        >
          {({ isValid, setFieldValue, values }) => (
            <Form>
              {fundraiser.roster_enabled &&
              fundraiser.roster !== null &&
              fundraiser.roster.length > 0 ? (
                <Field
                  name="student_name"
                  label={fundraiser.beneficiary_title || fundraiser.student_classification || 'student'}
                  onChange={handleStudent(setFieldValue)}
                  as="select"
                  value={values.roster_idx}
                  custom
                >
                  <option value=""></option>
                  {fundraiser.roster.map(({ first_name, last_name }, idx) => (
                    <option key={idx} value={idx}>
                      {first_name} {last_name}
                    </option>
                  ))}
                </Field>
              ) : (
                <>
                  <Field name="first_name" label={`${fundraiser.beneficiary_title || fundraiser.student_classification || 'student'} First Name`} />
                  <Field name="last_name" label={`${fundraiser.beneficiary_title || fundraiser.student_classification || 'student'} Last Name`} />
                </>
              )}
              <div className="d-flex justify-content-between align-items-center">
                <Button variant="link" size="sm" onClick={skip}>
                  Skip this step
                </Button>
                <Button type="submit" variant="primary">
                  Next
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </Card.Body>
    </Card>
  )
}

FormCard.propTypes = {
  fundraiser: PropTypes.object.isRequired,
  initial: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
}

export default FormCard
